var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25524 1.42919L8.25873 1.43056H8.25957C8.56696 1.55561 8.86198 1.70595 9.14114 1.87765C9.41819 2.04819 9.68245 2.24317 9.93043 2.45857C11.198 3.55969 12.0001 5.18428 12.0001 6.99496V6.99666H11.9995C11.9988 8.65425 11.3271 10.1558 10.2413 11.2419C9.15721 12.3269 7.65854 12.9986 6.00365 12.9995V13.0001H6.00016H5.99857V12.9995C4.34262 12.999 2.84279 12.3269 1.75743 11.2404L1.7569 11.2408C0.672803 10.1557 0.00158555 8.65552 0.000634222 6.99835H0V6.99486V6.99073H0.000634222C0.00105704 6.26096 0.131601 5.56133 0.369751 4.91556C0.466576 4.65255 0.58211 4.39748 0.713816 4.15278C1.38937 2.89667 2.49978 1.90854 3.84296 1.39036L4.12138 1.28277V1.58079V3.57767V3.69288L4.02128 3.75308L4.02054 3.75351L4.0197 3.75403L4.01896 3.75446C3.86695 3.84766 3.72203 3.95177 3.58547 4.06391L3.58589 4.06433C3.44805 4.17848 3.31825 4.30152 3.19912 4.43218H3.19838C2.58202 5.10663 2.20551 6.00652 2.20551 6.99454V6.99623H2.20477C2.20498 8.0436 2.63054 8.99333 3.31751 9.68078L3.31708 9.68121C4.00331 10.3676 4.95094 10.7927 5.99657 10.7933V10.7927H6.00005H6.00164V10.7933C7.04884 10.7931 7.99764 10.3675 8.68376 9.68057C9.36988 8.99364 9.7945 8.04519 9.79534 6.99814H9.7945V6.99464V6.992H9.79534C9.79513 6.32602 9.62273 5.69908 9.32137 5.15519C9.27369 5.06939 9.22063 4.98232 9.16323 4.89567C8.87583 4.4635 8.50237 4.09258 8.06825 3.80958L7.9747 3.74853V3.63829V1.61898V1.31673L8.25524 1.42919ZM5.02187 0H6.97813H7.18298V0.204925V5.4914V5.69633H6.97813H5.02187H4.81712V5.4914V0.204925V0H5.02187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutButtonIcon);
export default __webpack_public_path__ + "static/media/logout-button-icon.2007d90634aedd1baef9d4ca510e6af8.svg";
export { ForwardRef as ReactComponent };